/**
 * OneVet Article v2 — Reading progress, TOC autogeneration, share, scroll spy
 */
(function () {
  'use strict';

  const article = document.querySelector('[data-av2-article]');
  if (!article) return;

  /* ---------- 0. Eski tema breadcrumb'ını DOM'dan kaldır ---------- */
  // Tema layout'unda inject edilen ".breadcrumb" elementi (v2 kendi breadcrumb'ını çiziyor)
  document.querySelectorAll('.breadcrumb:not(.av2-breadcrumb)').forEach((el) => {
    el.remove();
  });

  const progressBar = document.querySelector('[data-av2-progress-bar]');
  const body = article.querySelector('[data-av2-body]');
  const tocList = article.querySelector('[data-av2-toc-list]');
  const tocToggle = article.querySelector('[data-av2-toc-toggle]');

  /* ---------- 1. Reading Progress ---------- */
  function updateProgress() {
    if (!progressBar || !body) return;
    const rect = body.getBoundingClientRect();
    const start = window.scrollY + rect.top - 100;
    const end = window.scrollY + rect.bottom - window.innerHeight + 80;
    const cur = window.scrollY;
    const pct = Math.max(0, Math.min(100, ((cur - start) / Math.max(1, end - start)) * 100));
    progressBar.style.width = pct + '%';
  }
  window.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress, { passive: true });
  updateProgress();

  /* ---------- 2. TOC Auto-generation from h2/h3 ---------- */
  function slugify(s) {
    return (s || '')
      .toLowerCase()
      .replace(/ı/g, 'i').replace(/ö/g, 'o').replace(/ü/g, 'u')
      .replace(/ş/g, 's').replace(/ç/g, 'c').replace(/ğ/g, 'g')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  const headings = body ? body.querySelectorAll('h2') : [];
  if (tocList && headings.length > 0) {
    headings.forEach((h, i) => {
      let id = h.id;
      if (!id) {
        id = slugify(h.textContent) || ('s-' + i);
        h.id = id;
      }
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent.trim();
      a.dataset.av2TocLink = id;
      li.appendChild(a);
      tocList.appendChild(li);
    });
  } else if (tocList) {
    // Hide TOC if no headings
    const tocEl = article.querySelector('[data-av2-toc]');
    if (tocEl) tocEl.style.display = 'none';
  }

  // TOC toggle (mobile)
  if (tocToggle) {
    tocToggle.addEventListener('click', () => {
      const open = tocToggle.getAttribute('aria-expanded') === 'true';
      tocToggle.setAttribute('aria-expanded', !open);
    });
  }

  // Smooth scroll for TOC links
  if (tocList) {
    tocList.addEventListener('click', (e) => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;
      const id = link.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top, behavior: 'smooth' });
      history.replaceState(null, '', '#' + id);
      // Close mobile toc
      if (window.innerWidth < 1100 && tocToggle) {
        tocToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- 3. Scroll Spy ---------- */
  if (tocList && headings.length > 0 && 'IntersectionObserver' in window) {
    const links = tocList.querySelectorAll('a[data-av2-toc-link]');
    const linkById = {};
    links.forEach((l) => { linkById[l.dataset.av2TocLink] = l; });

    let currentActive = null;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          if (linkById[id] && currentActive !== id) {
            if (currentActive && linkById[currentActive]) linkById[currentActive].classList.remove('is-active');
            linkById[id].classList.add('is-active');
            currentActive = id;
          }
        }
      });
    }, { rootMargin: '-80px 0px -60% 0px', threshold: 0 });

    headings.forEach((h) => observer.observe(h));
  }

  /* ---------- 4. Copy link ---------- */
  const copyBtn = article.querySelector('[data-av2-copy-link]');
  if (copyBtn) {
    copyBtn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(window.location.href);
        const orig = copyBtn.getAttribute('aria-label');
        copyBtn.setAttribute('aria-label', 'Kopyalandı!');
        copyBtn.style.background = 'var(--av2-primary)';
        copyBtn.style.color = '#fff';
        copyBtn.style.borderColor = 'var(--av2-primary)';
        setTimeout(() => {
          copyBtn.setAttribute('aria-label', orig);
          copyBtn.style.background = '';
          copyBtn.style.color = '';
          copyBtn.style.borderColor = '';
        }, 1500);
      } catch (_) {}
    });
  }

  /* ---------- 5. Mobile share (Web Share API) ---------- */
  const mobileShareBtn = document.querySelector('[data-av2-mobile-share]');
  if (mobileShareBtn && navigator.share) {
    mobileShareBtn.addEventListener('click', async () => {
      try {
        await navigator.share({
          title: document.title,
          url: window.location.href,
        });
      } catch (_) {}
    });
  } else if (mobileShareBtn) {
    // Fallback: WhatsApp share
    mobileShareBtn.addEventListener('click', () => {
      const url = `https://wa.me/?text=${encodeURIComponent(document.title + ' ' + window.location.href)}`;
      window.open(url, '_blank', 'noopener');
    });
  }

  /* ---------- 6. External link safety (rel + target) ---------- */
  if (body) {
    body.querySelectorAll('a[href^="http"]').forEach((a) => {
      try {
        const url = new URL(a.href);
        if (url.hostname !== window.location.hostname) {
          a.target = '_blank';
          a.rel = 'noopener noreferrer';
        }
      } catch (_) {}
    });
  }

  /* ---------- 7. Lazy-fix images in content ---------- */
  if (body) {
    body.querySelectorAll('img').forEach((img) => {
      if (!img.hasAttribute('loading')) img.loading = 'lazy';
      if (!img.hasAttribute('decoding')) img.decoding = 'async';
    });
  }
})();
